import { Component } from "@angular/core";

@Component({
    selector: "icon-check-modal",
    templateUrl: "./check_modal.svg",
    standalone: false
})
export class CheckModalIconComponent {}
